export default __webpack_public_path__ + "static/media/micron-technology.29612f47.svg";